import Image from 'next/legacy/image';

import styled from '../../../theme/styled-with-theme';
import { pxToRem } from '../../../styles/utils';
import { breakpoints, mediaQueries } from '../../../styles/media-queries';

import { GlImage } from '../../Image';
import { Box } from '../../Box';
import { Text } from '../../Text';
import { BlockContainer, Column } from '~/components/Layout';
import { Flexbox } from '~/components/Flexbox';
import { GreenlightThemeOptions } from '~/theme/themes/greenlight';

export const DesktopBlockContainer = styled(BlockContainer)`
  display: none;

  ${mediaQueries.tablet} {
    display: flex;
  }
`;

export const SpacerColumn = styled(Column)`
  ${mediaQueries.tablet} {
    display: none;
  }

  ${mediaQueries.desktop} {
    display: flex;
  }
`;

export const MobileImage = styled(GlImage)`
  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopImage = styled(GlImage)<{
  visibility: string;
}>`
  visibility: ${({ visibility }) => visibility};
  border-radius: ${({ theme }) => theme.borderRadius.milestoneShape};
`;

export const VerticalDivider = styled('div')`
  margin: auto ${({ theme }) => theme.spacing.s};
  max-height: ${pxToRem(56)};

  ${mediaQueries.desktop} {
    margin: auto ${({ theme }) => theme.spacing.sm};
    max-height: ${pxToRem(62)};
  }
`;

export const LogoContainer = styled('div')<{
  useGreenlightIcon?: boolean | null;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: ${pxToRem(88)};
  width: 90%;
  margin: auto;
  justify-content: center;

  ${mediaQueries.tablet} {
    justify-content: flex-start;
    margin: 0;
  }

  ${mediaQueries.desktop} {
    min-height: auto;
  }
`;

export const PositionerBox = styled(Box)<{
  useGreenlightIcon?: boolean | null;
}>`
  display: ${({ useGreenlightIcon }) => (useGreenlightIcon ? 'flex' : 'block')};
  flex: 0.1 1 auto;
  justify-content: ${({ useGreenlightIcon }) =>
    useGreenlightIcon ? 'center' : 'auto'};

  ${mediaQueries.desktop} {
    justify-content: ${({ useGreenlightIcon }) =>
      useGreenlightIcon ? 'flex-start' : 'auto'};
    flex: none;
  }
`;

export const StyledGreenlightIcon = styled(Image)`
  max-width: 100%;
  margin: auto;

  ${mediaQueries.desktop} {
    margin: 0;
  }
`;

export const AffiliateLogo = styled('img')<{
  logoHeight: string;
}>`
  max-height: ${({ logoHeight }) => logoHeight};
  max-width: 100%;
`;

export const CTAText = styled(Text)`
  margin: 0 auto;
  padding-bottom: ${({ theme }) => theme.spacing.s};
`;

export const QrCodeWrapper = styled(Flexbox)`
  height: 500px;
  justify-content: center;

  @media (max-width: ${breakpoints.desktop}px) {
    height: 300px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    height: 0px;
  }
`;

export const QrCodeContainer = styled(Flexbox)`
  justify-content: center;
  align-items: center;
  position: absolute;
  min-height: 100%;
  min-width: 50%;

  @media (max-width: ${breakpoints.tablet}px) {
    display: none;
  }

  /* Additional styling for screens wider than 720px */
  ${mediaQueries.tablet} {
    /* Styles for larger devices */
    display: flex; /* Ensures Flexbox properties are applied */
    position: relative; /* Resets position to default */
    min-height: 0; /* Resets min-height to default */
    min-width: 100%;
  }

  ${mediaQueries.desktop} {
    position: absolute;
    min-height: 100%;
    min-width: 50%;
  }

  #appsflyer-qr-code-container canvas {
    height: 400px;
    width: 400px;
    padding: 50px;
    border: 2px solid ${GreenlightThemeOptions.COLORS.GREEN};
    box-shadow: -10px 10px 3px 0 ${GreenlightThemeOptions.COLORS.GREEN};
    border-radius: 50px;
  }

  @media (max-width: ${breakpoints.desktop}px) {
    #appsflyer-qr-code-container canvas {
      height: 320px;
      width: 320px;
      border-radius: 0px;
      padding: 10px;
    }
  }
`;
